import React, { Component } from 'react';
import { transformations } from '../utilities';

export default class Image extends Component {
  render() {

    const { image, side, direction, callback, fill, componentProps} = this.props;

    if ( image === undefined || transformations[image] === undefined) { return null };

    const ratio = 0.90 * side / Math.max(transformations[image].width, transformations[image].height);

    const imageTranslationX =
      side  / 2
        - ratio * transformations[image].width  / 2
        - ratio * transformations[image].x
      + ((direction === 0 ? 1 : direction) * transformations[image].orientation < 0 ? ratio * transformations[image].width + ratio * transformations[image].x * 2 : 0);

    const imageTranslationY =
      side / 2 - ratio * ( transformations[image].height / 2 + transformations[image].y);

    const imageTransform = `rotate(${direction === 0 ? 180 : 0 },`
      + ` ${this.props.side / 2}, ${this.props.side / 2})`
      + ` translate(${imageTranslationX},${imageTranslationY})`
      + ` scale(${transformations[image].orientation * (direction !== 0 ? direction : 1) * ratio},${ratio}) `

    return (
      <use
        xlinkHref = {'#' + image}
        transform = {imageTransform}
        onClick   = {callback}
        fill      = { fill }
        {...componentProps}
      />
    )
  }
};

Image.defaultProps = {
  fill : 'black',
  direction : 1,
}



// WEBPACK FOOTER //
// ./src/components/Image.js